// extracted by mini-css-extract-plugin
module.exports = {"activeBtn":"Filters_activeBtn__xpp4S"};